import script from "./ClientInvoices.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientInvoices.vue?vue&type=script&setup=true&lang=ts"

import "./ClientInvoices.vue?vue&type=style&index=0&id=090e380a&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-090e380a"]])

export default __exports__